<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      class="width550"
      :show-close="false"
      top="10vh"
      @close="close"
      center
    >
      <div ref="captureElement" v-if="data" class="box">
        <div class="box-top">
          <img :src="data.Avatar" alt="" />
          <span class="RealName">{{ data.RealName }}</span>
        </div>
        <div class="detail">
          <p>课程分享：</p>
          <div class="detail-box">
            <img
              :src="imgPath"
              alt=""
              @error="imgError"
              crossOrigin="anonymous"
            />
            <span class="ml10 CourseName">{{ couseDetail.CourseName }}</span>
          </div>
        </div>
        <img
          :src="qrcodeUrl"
          alt=""
          id="qrcode-img"
          style="margin: 20px auto; width: 300px; display: block"
        />
        <p class="tip">好课共分享，知识同成长</p>
      </div>
      <div id="text" style="opacity: 0; height: 1px">{{ url }}</div>
      <div class="close-btn" @click="close">
        <img src="@/assets/img/8.png" alt="" crossOrigin="anonymous" />
      </div>
      <div slot="footer" class="flex size16 mb40 footer-btns">
        <template>
          <el-button class="testBtn" @click="captureDOM()">
            <img src="@/assets/img/7.png" alt="" />
            保存图片
          </el-button>

          <el-button
            data-clipboard-target="#text"
            data-clipboard-action="copy"
            class="testBtn copy-btn"
            @click="copyUrl()"
          >
            <img src="@/assets/img/6.png" alt="" />复制分享链接</el-button
          >
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import Clipboard from "clipboard"; // 引入安装复制插件
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: [Object],
    couseDetail: [Object],
  },
  watch: {
    show(val) {
      if (val) {
        this.visible = true;
        const imgElement = document.getElementById("qrcode-img");
        this.urlToBase64(this.webUrl + this.data.QrCode).then((base64) => {
          this.qrcodeUrl = base64;
        });
        this.urlToBase64(this.data.ImgPath).then((base64) => {
          this.imgPath = base64;
        });
      } else {
        this.visible = false;
      }
    },
  },
  data() {
    return {
      visible: false,
      url: "",
      qrcodeUrl: "",
      imageData: null,
      imgPath: "",
      webUrl: window.webUrl,
    };
  },
  methods: {
    urlToBase64(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // 关键
        img.src = url + "?t=" + Date.now(); // 加时间戳防缓存
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png")); // 输出Base64
        };
      });
    },
    async captureDOM() {
      this.statusMessage = "正在生成图片...";
      this.statusType = "";

      try {
        const element = this.$refs.captureElement;
        const options = {
          backgroundColor: "#ffffff",
          scale: 1,
          useCORS: true,
          allowTaint: false,
          logging: false,
        };

        // 显示加载状态
        this.imageData = null;

        // 使用html2canvas转换DOM为图片
        const canvas = await html2canvas(element, options);

        // 将canvas转换为data URL
        this.imageData = canvas.toDataURL("image/png");
        this.saveImage();
      } catch (error) {
        console.error("生成图片失败:", error);
        this.statusMessage = "生成图片失败: " + error.message;
        this.statusType = "error";
      }
    },

    saveImage() {
      if (!this.imageData) return;

      try {
        // 创建一个下载链接
        const link = document.createElement("a");
        link.href = this.imageData;
        link.download = "dom-capture-" + new Date().getTime() + ".png";

        // 触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.statusMessage = "图片已保存！";
        this.statusType = "success";
      } catch (error) {
        console.error("保存图片失败:", error);
        this.statusMessage = "保存图片失败: " + error.message;
        this.statusType = "error";
      }
    },
    //js
    downloadClick() {
      const canvas = document
        .getElementsByTagName("canvas")[0]
        .toDataURL("image/png");
      const alink = document.createElement("a");
      alink.setAttribute("href", canvas);
      alink.download = "qrCode.png";
      alink.click();
    },

    saveImg() {
      this.downloadIamge(this.imgUrl, "这是一张图片");
    },
    shareWx() {},
    async copyUrl() {
      const link =window.location.href + '&ShareAuthKey='+ this.data.ShareAuthKey;
      const textarea = document.createElement('textarea');
      textarea.value = link;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
      this.$message.success("链接已复制");
      } catch (err) {
        console.log(err);

      } finally {
        document.body.removeChild(textarea);
      }

    },
    confrimbtn() {
      this.$emit("confrimbtnFun");
    },
    close() {
      this.$emit("closeFun");
    },
  },
};
</script>
<style lang="scss" scoped>
.width550 {
  ::v-deep .el-dialog {
    width: 550px;
  }
}
.footer-btns {
  justify-content: center;
}
::v-deep .el-dialog__header {
  display: none !important;
}
.box {
  padding: 20px 30px;

  .box-top {
    margin: 0 auto;
    width: 457px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    .RealName {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
    }
    img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
  }
}
.detail {
  margin: 0 auto;
  margin-top: 20px;
  // width: 457px;
  height: 137px;
  padding: 10px 20px;
  background: #f6f8fc;
  border-radius: 10px;
  p {
    font-size: 16px;
    color: #999999;
  }
  .detail-box {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #333333;
    img {
      width: 100px;
      height: 75px;
      border-radius: 6px;
    }
    .CourseName {
      display: -webkit-box;
      overflow: hidden; /* 超出的文本隐藏 */
      text-overflow: ellipsis; /* 溢出用省略号显示 */
      -webkit-box-orient: vertical; /* 垂直排列子元素 */
      -webkit-line-clamp: 2; /* 显示的行数 */
    }
  }
}
.qrcode {
  width: 256px;
  height: 256px;
  border-radius: 10px;
  border: 1px solid #dedfe3;
  margin: 20px auto;
  padding: 12px;
  // width: 237px;
  // height: 233px;
}
.tip {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
}
.confirmBtn {
  width: 100px;
  color: #fff;
  text-align: center;
  background-color: #1890ff;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  margin: 30px auto 0;
}
.testBtn {
  font-size: 16px;
  display: flex;
  align-items: center;
  height: 46px;
  line-height: 46px;
  border-radius: 23px;
  border: 1px solid #cccccc;
  img {
    width: 24px;
    height: 24px;
    margin-top: -3px;
    margin-right: 5px;
  }
}
.close-btn {
  position: absolute;
  bottom: -70px;
  left: 250px;
  cursor: pointer;
  img {
    width: 44px;
    height: 44px;
  }
}
</style>
